import {Component, computed, inject, input, OnDestroy, OnInit, signal} from '@angular/core';
import {ControlContainer, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {FactoryIcon, HouseHeartIcon, LandmarkIcon, LightbulbIcon, LucideAngularModule, UserIcon} from 'lucide-angular';
import {Subject, takeUntil} from 'rxjs';
import {StringFieldComponent} from '@shared/form/string/string-field/string-field.component';
import {TextFieldComponent} from '@shared/form/string/text-field/text-field.component';
import {HostForm} from '@domain/host/component/form/host-editor/host-editor';
import {HostAbout, HostDTO, LegalForm} from '@domain/host/host.dto';
import {Choice} from '@shared/form/choice/choice';
import {ChoiceRadioFieldComponent} from '@shared/form/choice/choice-radio-field/choice-radio-field.component';
import {HostUtil} from '@domain/host/host.util';

@Component({
  selector: 'app-host-about-editor',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslocoDirective,
    LucideAngularModule,
    StringFieldComponent,
    TextFieldComponent,
    ChoiceRadioFieldComponent
  ],
  providers: [],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, {skipSelf: true})
    }
  ],
  templateUrl: './host-about-editor.component.html'
})
export class HostAboutEditorComponent implements OnInit, OnDestroy {

  private readonly controlContainer = inject(ControlContainer);

  public readonly form = computed(() => this.controlContainer.control as unknown as HostForm);
  public readonly aboutForm = computed(() => this.form().controls.about);
  public readonly formValue = signal<HostAbout | null>(null);
  public readonly host = input.required<HostDTO>();

  public readonly icons = {
    idea: LightbulbIcon,
  };

  public readonly legalFormChoices = HostUtil.getLegalFormChoices();

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.formValue.set(this.aboutForm().value);
    this.aboutForm().valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(value => this.formValue.set(value));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }
}
